import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_docline_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_job_hdr: fromDatatype.GuidDataFieldInterface;
  guid_dochdr_link: fromDatatype.GuidDataFieldInterface;
  guid_inv_item_hdr: fromDatatype.GuidDataFieldInterface;
  guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.TextDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  recipient_name: fromDatatype.VarcharDatatypeInterface;
  recipient_contact: fromDatatype.VarcharDatatypeInterface;
  id_recipient: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  qty_to_deliver: fromDatatype.NumericDatatypeInterface;
  qty_delivered: fromDatatype.NumericDatatypeInterface;
  installation_duration_minute: fromDatatype.IntegerDatatypeInterface;
  proof_of_received: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  item_type:fromDatatype.VarcharDatatypeInterface;
item_subtype:fromDatatype.VarcharDatatypeInterface;
sales_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
sales_invoice_process_status:fromDatatype.VarcharDatatypeInterface;
serial_no_json:fromDatatype.JsonDatatypeInterface;
batch_no_json:fromDatatype.JsonDatatypeInterface;
bin_no_json:fromDatatype.JsonDatatypeInterface;
}

export class bl_del_job_docline_link_RowClass
  implements bl_del_job_docline_link_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_job_hdr: fromDatatype.GuidDataFieldInterface;
  guid_dochdr_link: fromDatatype.GuidDataFieldInterface;
  guid_inv_item_hdr: fromDatatype.GuidDataFieldInterface;
  guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.TextDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  recipient_name: fromDatatype.VarcharDatatypeInterface;
  recipient_contact: fromDatatype.VarcharDatatypeInterface;
  id_recipient: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  qty_to_deliver: fromDatatype.NumericDatatypeInterface;
  qty_delivered: fromDatatype.NumericDatatypeInterface;
  installation_duration_minute: fromDatatype.IntegerDatatypeInterface;
  proof_of_received: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  item_type:fromDatatype.VarcharDatatypeInterface;
item_subtype:fromDatatype.VarcharDatatypeInterface;
sales_invoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
sales_invoice_process_status:fromDatatype.VarcharDatatypeInterface;
serial_no_json:fromDatatype.JsonDatatypeInterface;
batch_no_json:fromDatatype.JsonDatatypeInterface;
bin_no_json:fromDatatype.JsonDatatypeInterface;
}
